import { Button, ButtonProps, Tooltip } from 'antd';
import { genTestID } from '../utils/utils';

export interface TaggedTooltipButtonOwnProps extends ButtonProps{
  tag:string
  tooltiptext?: string
}

const TaggedTooltipButton = (props:TaggedTooltipButtonOwnProps) => {
  const {
    tag, tooltiptext,
  } = props;

  return (
    <Tooltip title={tooltiptext}>
      <Button {...props} data-testid={genTestID('tooltipButton', tag)} />
    </Tooltip>
  );
};

TaggedTooltipButton.defaultProps = {
  tooltiptext: '',
};

export default TaggedTooltipButton;
